module.exports = __webpack_public_path__ + "img/the-strength-of-the-few.4ccf9e5e.png";